import React from 'react'
import Text from '../Text'
import * as Styled from './styled'
import { IDropdownItemProps } from './types'

export const DropdownItem: React.FC<IDropdownItemProps> = ({
  title,
  description,
  isSelected,
  onSelect,
  renderRightContent
}) => {
  return (
    <Styled.ItemWrapper $isSelected={isSelected} onClick={onSelect}>
      <Styled.TextContent>
        <Text
          type="subtitle"
          color={isSelected ? 'secondaryDark' : 'secondarySemiDark'}
        >
          {title}
        </Text>
        {description && (
          <Text type="h4" color="secondarySemiDark">
            {description}
          </Text>
        )}
      </Styled.TextContent>

      {renderRightContent && renderRightContent()}
    </Styled.ItemWrapper>
  )
}

export default DropdownItem
